import { DashboardsPaths } from 'app/configs/routesConfig/dashboards';

export const NAVIGATION_ITEM_TYPE = {
  ITEM: 'item',
  GROUP: 'group',
  COLLAPSE: 'collapse',
};

export const NAVIGATION_CONTAINER_TYPES = [
  NAVIGATION_ITEM_TYPE.GROUP,
  NAVIGATION_ITEM_TYPE.COLLAPSE,
];

export const START_PAGE_PATH = DashboardsPaths.dashboards.path;

export const ERROR_PAGES_PATH_PREFIX = '/pages/errors';
